import { useEffect, useMemo, useState } from "react";
import { Search, Download } from "lucide-react";
import { http } from "@/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { PageHeader, Pill, fmtDateTime, exportXlsx } from "./ui";

export default function AuditPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [entity, setEntity] = useState("");
  useEffect(() => { http.get("/audit").then((r) => setRows(r.data)); }, []);
  const entities = [...new Set(rows.map((r) => r.entity))];
  const list = useMemo(() => rows.filter((r) => (!entity || r.entity === entity) && `${r.action} ${r.entity} ${r.entity_id}`.toLowerCase().includes(q.toLowerCase())), [rows, q, entity]);
  return (
    <div data-testid="admin-audit-page">
      <PageHeader title="Historial de modificaciones" subtitle="Registro de todos los cambios realizados"
        actions={<Button variant="outline" onClick={() => exportXlsx(list.map((r) => ({ Fecha: fmtDateTime(r.created_at), Acción: r.action, Sección: r.entity, Referencia: r.entity_id, Usuario: r.actor })), "historial-floral-rosse", "Historial")}><Download size={14} className="mr-1" /> Excel</Button>} />
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="relative flex-1 min-w-[200px]">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar" className="pl-9 bg-white" data-testid="audit-search" />
        </div>
        <select value={entity} onChange={(e) => setEntity(e.target.value)} className="h-10 rounded-md border border-input px-3 text-sm bg-white" data-testid="audit-filter">
          <option value="">Todas las secciones</option>
          {entities.map((e) => <option key={e} value={e}>{e}</option>)}
        </select>
      </div>
      <div className="bg-white rounded-2xl border border-black/5 divide-y" data-testid="audit-list">
        {list.length === 0 && <p className="text-sm text-neutral-500 p-8 text-center">Sin registros.</p>}
        {list.map((r) => (
          <div key={r.id} className="flex items-center justify-between gap-3 px-4 py-3 text-sm">
            <div className="flex items-center gap-2 flex-wrap">
              <Pill className={r.actor === "cliente" ? "bg-sky-100 text-sky-800" : "bg-neutral-100 text-neutral-700"}>{r.actor === "cliente" ? "Cliente" : "Admin"}</Pill>
              <span><b>{r.action}</b> {r.entity}{r.label ? `: ${r.label}` : ""}</span>
              {r.entity_id && !r.label && <span className="text-xs text-neutral-400 font-mono">{r.entity_id.slice(0, 8)}</span>}
            </div>
            <span className="text-xs text-neutral-500 whitespace-nowrap">{fmtDateTime(r.created_at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
